import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed, ref, watch } from 'vue';
import { Field, DropdownField } from '@samc/centricity-core';
import { SellerSource } from '@/Sources';
import { ISeller } from '@/Interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'SellerDropdownField',
  props: {
    value: { type: String, required: false },
    label: { type: String, required: false, default: 'Seller' },
    disabled: { type: Boolean, required: false, default: false },
    autoAssign: { type: Boolean, required: false, default: false },
    placeholder: { type: String, required: false },
    errorText: { type: String, required: false, default: '' },
    counterpartyId: { type: [String, null], required: false, default: () => null }
  },
  emits: ["input", "seller"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'input', value: string): void,
  (event: 'seller', value: ISeller): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: string, label: string, disabled: boolean, autoAssign: boolean, placeholder?: string, errorText: string, counterpartyId: string | null };




const source = ref(new SellerSource(true, props.counterpartyId));
const val = computed({
  get: () => props.value ?? '',
  set: (value: string) => {
    emits('input', value);

    const seller = source.value.items.find((item) => item.id === value);
    if (seller)
      emits('seller', seller);
  },
});

watch(() => props.counterpartyId, (newValue) => {
  source.value = new SellerSource(true, newValue);
});

watch(() => source.value.isLoaded, (newValue) => {
  if (newValue) {
    const seller = source.value.find((item) => item.id === val.value);
    if (seller === undefined)
      val.value = '';
  }
});

return { __sfc: true,props, emits, source, val, Field, DropdownField }
}

})